import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ProductsPage.css';
import { surgicalSets } from './surgicalSetsData';

const SurgicalSetsPage = () => {
  const [search, setSearch] = useState('');
  const handleImageError = (e) => {
    e.target.alt = 'Image not available';
    e.target.style.opacity = '0.2';
    e.target.style.background = '#eee';
    e.target.src = 'data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="300" height="180"><rect width="100%" height="100%" fill="#f3f4f6"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#9ca3af" font-family="Arial" font-size="16">Image not available</text></svg>';
  };

  // Safely encode only the filename part to handle spaces and special characters
  const toSafeSrc = (p) => {
    if (!p) return p;
    const i = p.lastIndexOf('/');
    const base = i >= 0 ? p.slice(0, i + 1) : '';
    const name = i >= 0 ? p.slice(i + 1) : p;
    try {
      return base + encodeURIComponent(name);
    } catch {
      return p;
    }
  };

  return (
    <section id="surgical-sets" className="products-page">
      <div className="container">
        <div className="products-header-row">
          <div className="section-header" style={{ textAlign: 'left', marginBottom: 0 }}>
            <h2 className="section-title">Surgical Sets</h2>
            <p className="section-description">Curated collections of instruments packaged as complete surgical sets.</p>
          </div>
        </div>

        <div className="search-bar-row">
          <input
            type="text"
            className="search-input"
            placeholder="Search surgical sets..."
            aria-label="Search surgical sets"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="products-list">
          {surgicalSets.filter(set => {
            const q = (search || '').trim().toLowerCase();
            if (!q) return true;
            return [set.name, set.description].some(v => v && v.toLowerCase().includes(q));
          }).map((set) => (
            <div
              data-product-id={set.id}
              key={set.id}
              style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}
            >
              <div style={{ background: '#f7fafc' }}>
                <img
                  src={toSafeSrc(set.image)}
                  alt={set.name}
                  onError={handleImageError}
                  loading="lazy"
                  style={{ width: '100%', height: '240px', objectFit: 'contain' }}
                />
              </div>
              <div style={{ padding: 16 }}>
                <h3 className="product-name" style={{ margin: '0 0 12px', fontSize: '1rem', fontWeight: 700 }}>
                  {set.name}
                </h3>
                <Link to={`/surgical-sets/${set.id}`} className="view-btn" aria-label={`View details of ${set.name}`}>
                  View Details
                </Link>
              </div>
            </div>
          ))}
        </div>

        {surgicalSets.filter(set => {
          const q = (search || '').trim().toLowerCase();
          if (!q) return false; // don't show message if just empty search
          return ![set.name, set.description].some(v => v && v.toLowerCase().includes(q));
        }).length === surgicalSets.length && (
          <div style={{ textAlign: 'center', marginTop: 24, color: '#374151' }}>
            No surgical sets match your search.
          </div>
        )}
      </div>
    </section>
  );
};

export default SurgicalSetsPage;